  <ng-container *ngIf="!isLoading; else loadingPage">
    <ng-container *ngIf="hasLocationAccess; else noLocationAccessPage">
    <mat-sidenav-container>
      <mat-sidenav 
        #sidenav 
        class="app-side-nav-container" 
        [mode]="sidenavMode" 
        [(opened)]="sidenavOpened" 
        [position]="isMobile ? 'end' : 'start'" 
        [ngClass]="{
          'sidenav-open': !isMobile && sidenavExpanded,
          'sidenav-closed': !isMobile && !sidenavExpanded,
          'mobile-sidenav': isMobile
        }"
      >
        <button mat-mini-fab (click)="toggle()" class="toggle-side-nav" *ngIf="!isMobile">
          <mat-icon [@rotateIcon]="sidenavExpanded ? 'open' : 'closed'" aria-label="Toggle Menu">chevron_left</mat-icon>
        </button>
        <app-side-nav 
          [isExpanded]="sidenavExpanded" 
          [navItems]="navItems" 
          [isMobile]="isMobile"
          [agentInfo]="agentInfo"
          (gotoNav)="gotoNav($event)"
          (closeNav)="closeSidenav()">
        </app-side-nav>
      </mat-sidenav>

      <mat-sidenav-content 
        [@openClose]="!isMobile ? (sidenavExpanded ? 'open' : 'closed') : 'none'" 
        (touchstart)="collapseIfExpanded()" 
      >
        <div class="container--full-width main-content">
          <app-top-nav
            [locationName]="locationName"
            (viewAccountEvent)="getAccountView()"
            [isAdminRole]="adminRole"
            [locations]="locations"
            [currentLocation]="currentLocation"
            (changeLocation)="changeLocationId($event)"
            [isMobile]="isMobile"
            (toggleMobileNav)="toggle()"
          ></app-top-nav>
          <router-outlet (activate)="onActivate($event)"></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
    </ng-container>
  </ng-container>
<ng-template #loadingPage>
  <div class="grid--center max--height bg--medium-navy">
    <mat-spinner class="primary-spinner"></mat-spinner>
  </div>
</ng-template>
<ng-template #noLocationAccessPage>
  <div class="grid--center max--height bg--medium-navy color--white">
    <div class="align-center">
      <p>{{ 'App.NoCorporateLocationsAssigned' | translate }}</p>
      <button mat-button class="primary-button rounded" type="button" (click)="logout()">
        {{ 'App.LogOut' | translate }}
      </button>
    </div>
  </div>
</ng-template>